import { useEffect, useState } from "react";
import { header, host } from "../globalVariables";
import { api, getStaticData } from "../pureFunctions";
import MemoryGame from "./MemoryGame";
import { useConfig } from "../ConfigContext";
import { Alert, Button, ButtonGroup, Container, Table } from "react-bootstrap";
import { useAuth } from "../AuthContext";

const levels = { Test: 4, Leicht: 9, Mittel: 16, Schwer: 49 };
export default function MitarbeiterMemory() {
   const config = useConfig();
   const { user } = useAuth();
   const [anzahl, setAnzahl] = useState(9);
   const [loading, setLoading] = useState();
   const [userList, setUserList] = useState([]);
   const [multiplayer, setMultiplayer] = useState(false);

   useEffect(() => {
      getInitialData();
   }, []);

   async function getInitialData() {
      let [newestatekacheln, cleanUserData, newfieldConfiguration] = await getStaticData();

      let immopilotUsers = await api
         .get("/api/ip/getImmopilotUsers")
         .then((data) => {
            console.log(data.data);
            return data.data.reduce((oldObj, item) => ({ ...oldObj, [item.username]: item }), {});
         })
         .catch((err) => {
            console.error(err);
         });
      console.log(immopilotUsers);

      setUserList(
         cleanUserData.userList.map((user) => ({
            ...user,
            standort: immopilotUsers[user.Name]?.standort ?? "",
            abteilung: config.nutzerVerwaltung.abteilungen?.[immopilotUsers?.[user.Name]?.abteilung] ?? "",
            description: immopilotUsers?.[user.Name]?.description ?? "",
            ranking: immopilotUsers?.[user.Name]?.misc ?? {},
         })),
      );
      console.log(cleanUserData.userList);
   }

   async function updateUserData(memoData) {
      console.log(memoData);
      setLoading("loading");

      const prevData = userList.filter((item) => item.Name === user.username)[0]?.ranking?.mitarbeitermemo;
      console.log(prevData);
      let memoArray;
      if (prevData) {
         if (Array.isArray(prevData)) {
            memoArray = [...prevData];
         } else {
            memoArray = [prevData];
         }

         if (memoData.zeit > memoArray[0].zeit) {
            memoArray.push(memoData);
         } else {
            memoArray.unshift(memoData);
         }
      } else {
         memoArray = [memoData];
      }

      const newMemoData = { mitarbeitermemo: memoArray };

      const savedResponse = await api
         .post("/api/ip/userData", { misc: newMemoData }, header)
         .then((data) => {
            console.log("saved Data");

            console.log(data);
            if (data.status === 200) {
               setLoading("success");
               let updatedUL = structuredClone(userList);
               const myuser = updatedUL.find((u) => u.Name === user.username);

               // Option 1: Find and mutate directly

               console.log(myuser);

               if (myuser) {
                  myuser.ranking = newMemoData;
               }

               console.log(myuser);

               console.log(updatedUL);

               setUserList(updatedUL);
            } else {
               setLoading("error");
            }
            setTimeout(() => {
               setLoading(false);
            }, 2000);
            return [data.data];
         })
         .catch((err) => {
            console.log(err);
         });
      return savedResponse;
   }

   async function updateStartTimeData(memoData) {
      console.log(memoData);
      setLoading("loading");

      const newMemoData = { memoStart: { t_s: new Date(), anzahl: memoData } };

      const savedResponse = await api
         .post("/api/ip/userData", { misc: newMemoData }, header)
         .then((data) => {
            console.log("saved Data");

            console.log(data);
            if (data.status === 200) {
               setLoading("success");
            } else {
               setLoading("error");
            }
            setTimeout(() => {
               setLoading(false);
            }, 2000);
            return [data.data];
         })
         .catch((err) => {
            console.log(err);
         });
      return savedResponse;
   }

   return (
      <>
         <div className="d-flex justify-content-center  flex-col align-items-center m-5">
            <ButtonGroup className="mb-3">
               <Button variant={multiplayer ? "outline-dark" : "dark"} onClick={() => setMultiplayer(false)}>
                  Einzelspieler
               </Button>
               <Button variant={multiplayer ? "dark" : "outline-dark"} onClick={() => setMultiplayer(true)}>
                  Multiplayer
               </Button>
            </ButtonGroup>

            {/* Spielregeln und Rangliste gehören zum Einzelspieler-Wettbewerb.
                Im Multiplayer wird weder Zeit gemessen noch etwas gespeichert. */}
            {!multiplayer && (
               <>
            <Alert className="px-5 w-100" style={{ maxWidth: "980px" }}>
               {/* <Button
                  onClick={() => {
                     updateUserData({ mitarbeitermemo: false  });
                     // updateUserData({ mitarbeitermemo: { zeit: 11, versuche: 2 } });
                  }}
               >
                  fsad
               </Button> */}
               <h2>Spielregeln</h2>
               <ol>
                  <li>Es gibt eine Qualifikation und ein Finale</li>
                  <li>Die schnellsten 5 Leute aus dem Qualifikationslevel landen im Finale</li>
                  <li>Das Trainingslevel kann unbegrenzt oft gespielt werden</li>
                  <li>
                     <strong>Das Qualifikationslevel kann nur einmal gespielt werden!!!</strong>
                  </li>
                  <li>Bei gleicher Zeit zählen die Anzahl der Versuche</li>
                  <li>Das Finale findet live bei Sekt`o Clock statt.</li>
               </ol>
               <strong>1. Platz: 5x 50€-Gutschein</strong>
               <br />
               <strong>2. Platz: 3x 50€-Gutschein</strong>
               <br />
               <strong>3. Platz: 2x 50€-Gutschein</strong>
               <br />
            </Alert>

            <Table
               hover
               striped
               // responsive
               className="mt-3"
               style={{ borderRadius: "20px", overflow: "hidden", width: "990px" }}
            >
               <thead>
                  <tr>
                     {/* <th> </th> */}
                     <th></th>
                     <th>Nachname</th>
                     <th>Vorname</th>
                     <th>Zeit</th>
                     <th>Versuche</th>
                     <th>Uhrzeit</th>
                  </tr>
               </thead>
               <tbody>
                  {userList
                     .filter((item) => item?.ranking?.["mitarbeitermemo"])
                     .sort((a, b) =>
                        parseFloat(
                           a?.ranking?.["mitarbeitermemo"]?.zeit ?? a?.ranking?.["mitarbeitermemo"]?.[0]?.zeit,
                        ) >
                        parseFloat(b?.ranking?.["mitarbeitermemo"]?.zeit ?? b?.ranking?.["mitarbeitermemo"]?.[0]?.zeit)
                           ? 1
                           : -1,
                     )
                     .map((item, index) => {
                        return (
                           <tr key={index + 1} style={index === 0 ? { "--bs-table-bg": "#ca0" } : {}}>
                              <td className="text-center">{index + 1}</td>
                              <td className="text-center">{item.Nachname}</td>
                              <td className="text-center">{item.Vorname}</td>
                              <td className="text-center">
                                 {item?.ranking?.["mitarbeitermemo"]?.zeit ??
                                    item?.ranking?.["mitarbeitermemo"]?.[0]?.zeit}{" "}
                                 s
                              </td>
                              <td className="text-center">
                                 {item?.ranking?.["mitarbeitermemo"]?.versuche ??
                                    item?.ranking?.["mitarbeitermemo"]?.[0]?.versuche}
                              </td>
                              <td className="text-center">
                                 {(item?.ranking?.["mitarbeitermemo"]?.t ?? item?.ranking?.["mitarbeitermemo"]?.[0]?.t)
                                    ? new Date(
                                         item?.ranking?.["mitarbeitermemo"]?.t ??
                                            item?.ranking?.["mitarbeitermemo"]?.[0]?.t,
                                      ).toLocaleString()
                                    : "-"}
                              </td>
                           </tr>
                        );
                     })}
               </tbody>
            </Table>
               </>
            )}
         </div>
         {!!userList?.length && (
            <MemoryGame
               // key: beim Umschalten wird die Komponente komplett neu
               // aufgebaut, damit kein Zustand zwischen den Modi hängen bleibt.
               key={multiplayer ? "mp" : "sp"}
               mitarbeiter={userList.filter((user) => user.standort && user.standort !== "-")}
               user={user}
               anzahl={anzahl}
               updateUserData={updateUserData}
               updateStartTimeData={updateStartTimeData}
               setAnzahl={setAnzahl}
               photoBaseUrl={host + "/images/"}
               onWin={(versuche) => console.log("Gewonnen nach", versuche, "Versuchen")}
               multiplayer={multiplayer}
               multiplayerUrl={host}
            />
         )}
      </>
   );
}
